export default __webpack_public_path__ + "d14cecc58668565e7d79815de627f1c1.json";